export class LinkFormatter {
  static googleSearchUrl(text: string) {
    let url = 'https://www.google.com/search?q=';
    text.split('').forEach(char => {
      if (char === ' ') {
        url = `${url}%20`;
      } else {
        url = `${url}${char}`;
      }
    });
    return url;
  }
}
